import { sendGAEvent, sendGALinkClickEvent } from '@noths/polaris-client-google-analytics';
import { ContentTilesTileProps } from '@noths/polaris-client-ribbons-design-system';

import { PlacementContext } from 'src/types/PlacementContext';

interface Tracking extends PlacementContext {
  numberOfTiles: number;
}

interface ContentTilesTracking extends Tracking {
  tile: Omit<ContentTilesTileProps, 'imageSrc'>;
  tileIndex: number;
}

export const trackImpression = ({ trackingPosition, trackingTitle, numberOfTiles }: Tracking) => {
  sendGAEvent({
    event: 'custom_event',
    event_action: 'Impression',
    event_category: `${trackingPosition} | Content tiles`,
    event_label: `${trackingPosition} | ${trackingTitle} | ${numberOfTiles}`.toLowerCase(),
    event_name: 'view_content',
    content_position: `${trackingPosition}`,
    content_type: `content tiles|${trackingTitle}`.toLowerCase(),
    total_options: `${numberOfTiles}`,
  });
};

export const trackLinkClick = async (
  e: React.MouseEvent<HTMLAnchorElement>,
  { trackingPosition, trackingTitle, tile, tileIndex, numberOfTiles }: ContentTilesTracking,
) => {
  const { title, url } = tile;

  await sendGALinkClickEvent(e, {
    event: 'custom_event',
    event_action: 'Tile click',
    event_category: `${trackingPosition} | Content tiles`,
    event_label: `${trackingPosition} | ${trackingTitle} | ${
      tileIndex + 1
    } | ${title}`.toLowerCase(),
    event_name: 'select_content',
    event_details: 'tile click',
    content_position: `${trackingPosition}`,
    content_type: `content tiles|${trackingTitle}`.toLowerCase(),
    total_options: `${numberOfTiles}`,
    selected_position: `${tileIndex + 1}`,
    item_id: `${title}`.toLowerCase(),
    destination_URL: `${url}`,
  });
};
